export const setStore = (key: string, value: any): void => {
    key = key.trim()
    if(!key) {
        throw new Error('key is empty')
    }
    if(!value && value !== 0) value = ''
    const valueStr = JSON.stringify(value)
    window.localStorage.setItem(key, valueStr)
}

export const getStore = (key: string) : any => {
    key = key.trim()
    if(!key) {
        throw new Error('key is empty')
    }
    const valueStr = window.localStorage.getItem(key)
    if(valueStr) {
        return JSON.parse(valueStr)
    } else {
        return ''
    }
}

export const removeStore = (key: string) => {
    key = key.trim()
    if(!key) {
        throw new Error('key is empty')
    }
    window.localStorage.removeItem(key)
}